import React, {useState} from "react"
import {Accordion, AccordionSummary, AccordionDetails} from "@mui/material"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import {getImageURL, sortImagePaths} from "@/utils"

export default function ImagesColumn({
   images,
   orderedSections,
}: {
   images: Record<string, string[]>
   orderedSections: string[]
}) {
   return (
      <>
         {Object.entries(sortImagePaths(images, orderedSections)).map(([key, value], index) => (
            <CollapsableSection title={key} key={index} images={value as string[]} />
         ))}
      </>
   )
}

interface SectionProps {
   title: string
   images: string[]
}

function CollapsableSection(props: SectionProps) {
   const [show, setShow] = useState(false)

   return (
      <Accordion
         expanded={show}
         onChange={() => {
            setShow(!show)
         }}
         className="my-2"
      >
         <AccordionSummary expandIcon={<ExpandMoreIcon />} className="font-bold">
            {props.title}
         </AccordionSummary>
         <AccordionDetails>
            <div className="mt-6 mb-6 grid grid-cols-1 md:grid-cols-2 gap-6 mx-6">
               {props.images?.map((image: string) => (
                  <img
                     key={image}
                     src={getImageURL(image)}
                     className="rounded-lg md:h-[300px] mx-auto"
                     alt=""
                  />
               ))}
            </div>
         </AccordionDetails>
      </Accordion>
   )
}
